import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import Home from './pages/Home';
import WeddingsEvents from './pages/WeddingsEvents';
import Gallery from './pages/Gallery';
import Accommodations from './pages/Accommodations';
import AboutUs from './pages/AboutUs';
import PrivacyNotice from './pages/PrivacyNotice';
import TermsOfService from './pages/TermsOfService';
import AccessibilityStatement from './pages/AccessibilityStatement';
import FAQS from './pages/FAQS';
import ScrollToTop from './components/ScrollToTop';
import BookingNoticeModal from './components/BookingNoticeModal';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <BookingNoticeModal />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/accomodations" element={<Accommodations />} />
          <Route path="/weddings-events" element={<WeddingsEvents />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-notice" element={<PrivacyNotice />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/faqs" element={<FAQS />} />
        </Routes>
      </div>
      <Analytics />
    </Router>
  );
}

export default App;
